/**
 * Returns class wrapper for querying success and error code of response.
 */

export interface IFormSubmitReponse {
	Success: boolean;
	Code?: string;
}

export interface IFormSubmitResponse {
	isSuccessful(): boolean;
	hasSubmitError(): boolean;
}

export class FormSubmitResponse implements IFormSubmitReponse {
	Success: boolean;
	Code: string;
	constructor(response: boolean) {
		this.Success = response;
		this.Code = "";
	}

	isSuccessful(): boolean {
		return this.Success;
	}

	hasSubmitError(): boolean {
		return this.Code === "ERROR";
	}
}
